import { Button, VStack, Text, Flex } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import React, { ReactElement } from 'react';
import { ModalWorksheetTemplateDeleteProps, SharedModalProps } from 'types/Modal';
import { CloseIcon } from 'assets/icons/v2';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalWorksheetTemplateDeleteProps;

export const WorksheetTemplateDeleteModal = ({
  handleClose,
  isShown,
  onDelete,
  templateName,
}: Props): ReactElement => {
  const handleDelete = (): void => {
    if (onDelete) {
      onDelete();
    }
    handleClose();
  };
  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="sm">
      <CustomModalContent p="30px">
        <Flex direction="column" gap="30px">
          <Flex direction="column" align="flex-end" gap="5px">
            <NovaIconButton
              aria-label="Schließen"
              variant="primary"
              size="l"
              onClick={handleClose}
              icon={CloseIcon}
              iconProps={{ color: 'text.primary' }}
            />
            <VStack gap="15px" align="flex-start" w="full">
              <Text textStyle="h4.medium" color="text.primary">
                Arbeitsblattvorlage &quot;{templateName}&quot; löschen
              </Text>
              <Text textStyle="body.m.regular" color="text.primary">
                Möchtest du die Arbeitsblattvorlage <b>{templateName}</b> wirklich löschen?
              </Text>
            </VStack>
          </Flex>

          <Flex gap="l" justify="flex-end">
            <Button onClick={handleClose} variant="tertiary">
              Abbrechen
            </Button>
            <Button onClick={handleDelete} variant="destructive">
              Löschen
            </Button>
          </Flex>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
